let isFetchingCart = false;

const updateCartBubble = (count) => {
  const cartCountBubble = document.getElementById('cart-count-bubble');
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  
  // Silent fail if elements don't exist yet
  if (!cartCountBubble || !cartIconBubble) {
    return;
  }

  // Update count bubble
  if (count === 0) {
    cartCountBubble.style.display = 'none';
    const ariaHidden = cartCountBubble.querySelector('[aria-hidden="true"]');
    const visuallyHidden = cartCountBubble.querySelector('.visually-hidden');
    
    if (ariaHidden) ariaHidden.textContent = '0';
    if (visuallyHidden) visuallyHidden.textContent = '0 items';
  } else {
    cartCountBubble.style.display = 'flex';
    const ariaHidden = cartCountBubble.querySelector('[aria-hidden="true"]');
    const visuallyHidden = cartCountBubble.querySelector('.visually-hidden');
    
    if (ariaHidden) ariaHidden.textContent = count;
    if (visuallyHidden) visuallyHidden.textContent = `${count} item${count !== 1 ? 's' : ''}`;
  }

  // Update cart icon
  const cartIcon = cartIconBubble.querySelector('.svg-wrapper');
  if (cartIcon && count > 0) {
    cartIcon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 28 28">
        <defs>
          <style>
            .cls-1 { fill: none; stroke: #f8f8f8; stroke-width: .9px; }
            .cls-2 { fill: #f8f8f8; }
          </style>
        </defs>
        <g>
          <g id="Layer_1">
            <g>
              <path class="cls-1" d="M23.2,22.1c-.4-.4-1-.6-1.6-.6s-.9.1-1.2.4c-.4.2-.6.6-.8,1-.2.4-.2.8-.1,1.3,0,.4.3.8.6,1.1.3.3.7.5,1.1.6.4,0,.9,0,1.3-.1.4-.2.7-.4,1-.8.2-.4.4-.8.4-1.2s-.2-1.1-.7-1.6ZM11.8,22.1c-.4-.4-1-.6-1.6-.6s-.9.1-1.2.4c-.4.2-.7.6-.8,1-.2.4-.2.8-.1,1.3,0,.4.3.8.6,1.1.3.3.7.5,1.1.6.4,0,.9,0,1.3-.1.4-.2.8-.4,1-.8.2-.4.4-.8.4-1.2s-.2-1.1-.6-1.6Z"/>
              <path class="cls-2" d="M27.8,7.7c0-.3-.2-.5-.3-.8-.2-.2-.4-.4-.6-.5-.2-.1-.5-.2-.8-.2H7.5l-.7-2.5c-.2-.6-.5-1-1-1.4-.5-.3-1-.5-1.6-.5H2.4c-.5,0-.9.2-1.3.5-.3.3-.5.8-.5,1.3s.2.9.5,1.2c.3.3.8.5,1.3.5h1.2l3.8,13.2c.2.7.7,1.4,1.3,1.8.6.5,1.4.7,2.1.7h10.5c.8,0,1.5-.2,2.1-.7.6-.4,1-1.1,1.3-1.8l3.1-10.1c0-.2,0-.3,0-.5s0-.2,0-.3ZM23.6,9.7l-2.4,7.8H10.7L8.5,9.7h15.1Z"/>
            </g>
          </g>
        </g>
      </svg>`;
  }
};

const fetchAndUpdateCartCount = () => {
  if (isFetchingCart) return;
  isFetchingCart = true;
  
  fetch('/cart.js', {
    cache: 'no-cache'
  })
    .then(response => {
      if (!response.ok) throw new Error(`Failed to fetch cart data: ${response.status}`);
      return response.json();
    })
    .then(cart => {
      if (typeof cart.item_count !== 'number') {
        console.error('Invalid cart data format');
        return;
      }
      updateCartBubble(cart.item_count);
    })
    .catch(error => console.error('Error:', error))
    .finally(() => {
      isFetchingCart = false;
    });
};

document.addEventListener('DOMContentLoaded', () => {
  // Check if elements exist before initializing
  if (document.getElementById('cart-count-bubble') &&
      document.getElementById('cart-icon-bubble')) {
    fetchAndUpdateCartCount();
    // Add-to-cart is handled solely by Dawn's product-form.js. This file only
    // keeps the cart count bubble in sync by listening for cart update events.
    document.addEventListener('cart:updated', fetchAndUpdateCartCount);
    document.addEventListener('cart:refresh', fetchAndUpdateCartCount);
  }
});